import { createSelector } from '@reduxjs/toolkit';

import { selectMatchedTaxonomyEntry } from './selectMatchedTaxonomyEntry';

/**
 * The shop PLP's `<meta name="description">` content, taken from the matched
 * taxonomy entry's Contentstack `seo.description`. Derived from the same matched
 * entry that drives the h1 and title, so it stays in sync across client-side
 * filter/navigation changes. Undefined when the content has no description, in
 * which case no description tag should be rendered.
 */
export const selectShopMetaDescription = createSelector(
  [selectMatchedTaxonomyEntry],
  (matchedEntry) => matchedEntry?.content?.metaTagDescription,
);
